import request from '@/utils/request';
import { getCacheTraceCode } from '@/utils/util';
// import qs from 'query-string';
/**
 * 获取商品详情页最大面额优惠券
 * @param params
 */
export const getProductCoupon = (params: any) => {
  return request('/products/productId/coupons', {
    ...params,
    type: 'NORMAL',
    displayPosition: 'RECOMMEND',
    traceCode: getCacheTraceCode()
  });
};

/**
 * 获取商品详情页弹框优惠券列表
 * @param params
 */
export const getProductCouponList = (params: any) => {
  return request('/products/productId/coupons', {
    ...params,
    type: 'NORMAL',
    displayPosition: 'MORE_LIST',
    traceCode: getCacheTraceCode()
  });
};

/**
 * 获取促销优惠券列表
 * @param params
 */
export const getPromotionCouponList = (params: any) =>
  request('/products/productId/coupons', { ...params, traceCode: getCacheTraceCode() });

/**
 * 获取优惠券活动详情
 * @param params
 */
export const getCouponActivityDetail = (params: any) => {
  const traceCode = getCacheTraceCode();
  return request('/api/activity/detail', { ...params, traceCode });
};

/**
 * 领取优惠券，批量couponIds以英文逗号间隔
 * @param params
 */
export const postPickCoupon = (params: any) => {
  const traceCode = getCacheTraceCode();
  return request('/api/activity/batch-pick', { ...params, traceCode });
};

/**
 * 根据链接id获取商品列表信息
 * @param params
 */
// export const getProductsByLinkIds = (params: any) =>
//   request('/api/product/link-product', qs.stringify(params), {
//     headers: { 'content-type': 'application/x-www-form-urlencoded;charset=utf-8' },
//   });
export const getProductsByLinkIds = (params: any) => request('/api/product/link-product', params);

/**
 * 根据availableStatus「可用状态」,productId获取用户优惠券
 * @param params
 */
export const getAvailableCoupons = (params: any) =>
  request('/api/activity/list-available-user-coupon', params);

// 获取促销优惠券
export async function getPromotionCoupon(params: any) {
  const traceCode = getCacheTraceCode();
  return request('/users/userId/coupons', { ...params, traceCode });
}

/**
 * 分页「validStatus, pageNum， pageSize」获取用户优惠券，并区分「已过期，已失效」状态
 * @param params
 */
export const getValidCoupons = (params: any) =>
  request('/api/activity/list-valid-user-coupon', params);

/**
 * 代金券列表
 */
export const getVoucherList = (params: any) => request('/v1/user/voucher-assets', params);

/**
 * 根据linkCode获取班期id
 * */
export function getClassIdsByLinkCode(params: any) {
  return request('/noRight/promotion-links/linkCode/classes', params);
}
